// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { isDarkMode } from '../../provider/types';
import { blue } from '../primitiveColors/blue';
import { common } from '../primitiveColors/common';
import { green } from '../primitiveColors/green';
import { grey } from '../primitiveColors/grey';
import { mutedRed, mutedYellow } from '../primitiveColors/muted';
import { purple } from '../primitiveColors/purple';
import { red } from '../primitiveColors/red';
import { yellow } from '../primitiveColors/yellow';
var light = {
    default: grey[300],
    soft: grey[200],
    heavy: grey[400],
    active: grey[500],
    heaviest: grey[950],
    focus: blue[400],
    white: common.white,
    action100: blue[300],
    action200: blue[400],
    actionBold: blue[500],
    status: {
        error: red[600],
        errorBold: red[600],
        errorSoft: red[300],
        errorHeavy: red[800],
        errorHeavier: red[900],
        info: blue[500],
        infoBold: blue[500],
        infoSoft: blue[300],
        infoHeavy: blue[600],
        success: green[600],
        successBold: green[500],
        successSoft: green[300],
        successHeavy: green[800],
        successHeavier: green[900],
        warning: yellow[500],
        warningBold: yellow[500],
        warningSoft: yellow[200],
        warningHeavy: yellow[700],
        warningHeavier: yellow[800],
        special: purple[500],
        specialBold: purple[500],
        specialHeavy: purple[700],
        specialSoft: purple[200]
    }
};
var dark = {
    default: grey[750],
    soft: grey[800],
    heavy: grey[600],
    active: grey[300],
    heaviest: grey[50],
    focus: grey[50],
    white: common.white,
    action100: grey[400],
    action200: grey[300],
    actionBold: grey[100],
    status: {
        error: mutedRed[700],
        errorBold: red[300],
        errorSoft: mutedRed[900],
        errorHeavy: mutedRed[600],
        errorHeavier: mutedRed[400],
        info: blue[600],
        infoBold: blue[400],
        infoSoft: blue[700],
        infoHeavy: blue[200],
        success: green[700],
        successBold: green[300],
        successSoft: green[900],
        successHeavy: green[600],
        successHeavier: green[400],
        warning: mutedYellow[600],
        warningBold: yellow[500],
        warningSoft: mutedYellow[800],
        warningHeavy: mutedYellow[500],
        warningHeavier: mutedYellow[400],
        special: purple[700],
        specialBold: purple[500],
        specialHeavy: purple[500],
        specialSoft: purple[800]
    }
};
export var border = function(mode) {
    return isDarkMode(mode) ? dark : light;
};

//# sourceMappingURL=border.js.map